import React from 'react';
import { Tabs as AntdTabs, TabsProps } from 'antd';
import classNames from 'classnames';

type Props = TabsProps & {
  borderRadius?: 'none' | 'default' | 'medium' | 'large';
};

export const Tabs = ({ className, children, ...antdProps }: Props) => {
  return (
    <AntdTabs {...antdProps} className={classNames('the5ers-tabs', className)}>
      {children}
    </AntdTabs>
  );
};

export const { TabPane } = AntdTabs;
